import NumberFormatInput from './NumberFormatInput';

export * from './NumberFormatInput';

export default NumberFormatInput;
